import React, { useEffect, useRef, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useHistory } from 'react-router';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useCognitoProvider } from '../../providers/CognitoContext';
import cognitoUtils from '../../utils/cognitoUtils';
import ButtonComponent from '../../components/Button/Button';
import { actions } from '../../actions/cognito';
import { CONFIG, INFO, UPDATED_AT } from '../../config';
import { useFetch } from '../../services/fetch';

const useStyles = makeStyles((theme) => ({
    dialogText: {
        color: theme.palette.text.primary
    }
}));

/**
 * Componente para la página de callback.
 * 
 * @returns {React.Component}
 */
export default function Callback() {

    const classes = useStyles();
    const theme = useTheme();
    const history = useHistory();
    const cognito = cognitoUtils;
    const [open, setOpen] = useState(true);
    const [headerMessage, setHeaderMessage] = useState('');
    const [message, setMessage] = useState('');
    const { state, dispatch } = useCognitoProvider();
    const userRef = useRef(null);
    const {interceptedFetch} = useFetch();

    /**
     * Al montar el componente logamos al usuario.
     */
    useEffect(() => { logUser(); }, []);

    /**
     * Función asíncrona para extraer el pkOPerador.
     * 
     * @param {Object} state El estado actual.
     * @param {Function} dispatch La función dispatcher.
     */
    async function getPkOperator(codOperador, idToken) {
        const config = CONFIG.api.find(f => f.key === 'PK');        
        if(!config) return;
        const url = config.endpoint + '/' + codOperador;
        const method = config.method;
        const response = await interceptedFetch(url, { method: method, headers: { 'Authorization': idToken, 'Content-Type': 'application/json' } });
        const responseData = await response.json();
        const pkOperador = responseData.PKOperador
        const admin = responseData.admin;
        if(pkOperador) {            
            dispatch({ type: actions.PK_OPERADOR, payload: { pkOperador: pkOperador, admin: admin } }); 
        }
        
    }

    /**
     * Función para obtener la ultima fecha de modificación de los endpoints
     * @param {String} idToken idToken
     * @returns void
     */
    async function getLastUpdatedDate(idToken) {
        const config = CONFIG.api.find(f => f.key === UPDATED_AT);
        if(!config) return;
        const url = config.endpoint;
        const method = config.method;
        const response = await interceptedFetch(url, { method: method, headers: { 'Authorization': idToken, 'Content-Type': 'application/json' } });
        const responseData = await response.json();
        if(responseData) {    
            dispatch({ type: actions.UPDATED_AT, payload: responseData });         
        }
    }

    /**
     * Función para controlar el proceso de login con cognito.
     */
    const logUser = async () => {
        if ((!history.location.hash && !history.location.search) || state.authToken) {
            history.push('/');
        }
        if (history.location.hash || history.location.search) {
            try {
                const auth = await cognito.parseCognitoWebResponse(window.location.href);
                const user = await cognito.getCognitoUser();
                userRef.current = user;
                user.getUserAttributes((err, result) => {
                    const attributes = result;
                    //const codOperador = 34400;
                    //const codOperador = 3033;
                    const codOperador = attributes.find(f => f.Name === 'custom:codOperador');
                    if (codOperador && codOperador.Value) {
                        const prefix = user.keyPrefix;
                        const idToken = user.storage[`${prefix}.${user.username}.idToken`]; 
                        getPkOperator(codOperador.Value, idToken);
                        getLastUpdatedDate(idToken);
                        window.localStorage.setItem(CONFIG.storage.cod, codOperador.Value);
                        dispatch({ type: actions.LOG_IN, payload: { user: user, codOperador: codOperador.Value } });                        
                        history.push('/');
                    }
                    else {
                        handleModalContents(
                            'Información',
                            `Su usuario no está completo. Si quiere más información, contacte con nosotros en la siguiente <a style="color: ${theme.palette.text.primary}" href="mailto:caae@caae.es">dirección de correo</a>.`
                        );
                    }
                });
            }
            catch (e) {
                handleModalContents('Error', e.message)
            }
        }
    }

    /**
     * Función para cerrar el modal cuando hay un error en la parte del login.
     */
    const handleCloseModal = () => dispatch({ type: actions.LOG_OUT });

    /**
     * Función de utilidad para mostrar los mensajes adecuados en el modal.
     * @param {String} headerMessage El mensaje de la cabecera en el modal.
     * @param {String} message El mensaje del cuerpo en el modal. Se inyecta como innerHTML
     */
    const handleModalContents = (headerMessage = '', message = '') => {
        setOpen(true);
        setHeaderMessage(headerMessage); 
        setMessage(message);
    }

    return (
        message 
        && message !== '' 
        &&
        <Dialog open={open}>
            <DialogTitle>{headerMessage}</DialogTitle>
            <DialogContent>
                <DialogContentText className={classes.dialogText} dangerouslySetInnerHTML={{__html: message}}></DialogContentText>
            </DialogContent>
            <DialogActions>
                <ButtonComponent onClick={handleCloseModal} color="primary">Cancelar</ButtonComponent>
            </DialogActions>
        </Dialog>
    )
}
